import { useId } from 'preact/hooks'
import { text } from '#contract'
import type { VendorView } from '#contract'
import { durationText } from '../../i18n/eta.ts'
import { useT } from '../../i18n/index.ts'
import { ShopApp } from './shop/shop-app.tsx'
import type { ShopSkin } from './shop/shop-context.ts'
import styles from './shop-skins.module.css'
import type { OsAppProps } from './types.ts'

/** The striped "24" mark, the wordmark and where it delivers, on 24Seven's white bar. */
function TwentyFourSevenBrand({ vendor }: { readonly vendor: VendorView | null }) {
  const t = useT()
  // One clip per instance: the phone and the computer can both show the bar.
  const clip = useId()
  return (
    <span class={styles.brand}>
      <svg class={styles.mark} viewBox="0 0 40 40" aria-hidden="true">
        <clipPath id={clip}>
          <rect width="40" height="40" rx="10" />
        </clipPath>
        <g clip-path={`url(#${clip})`}>
          <rect width="40" height="9" style={{ fill: 'var(--app-24seven-orange)' }} />
          <rect y="9" width="40" height="22" style={{ fill: 'var(--app-24seven-green)' }} />
          <rect y="31" width="40" height="9" style={{ fill: 'var(--app-24seven-red)' }} />
        </g>
        <text
          x="20"
          y="27"
          text-anchor="middle"
          style={{
            font: '900 19px var(--font-sans)',
            letterSpacing: '-1.5px',
            fill: 'var(--app-on-brand)',
          }}
        >
          24
        </text>
      </svg>
      <span class={styles.word}>
        <span class={styles.wordmark}>{t(vendor?.name ?? text('os.app.24seven.name'))}</span>
        {vendor && (
          <span class={styles.sub}>
            {t(text('shop.homeIn', { time: durationText(vendor.deliveryMinutes) }))}
          </span>
        )}
      </span>
    </span>
  )
}

const TWENTY_FOUR_SEVEN: ShopSkin = {
  app: '24seven',
  vendor: '24seven',
  brand: TwentyFourSevenBrand,
  home: 'aisles',
  sectionsTitle: text('shop.aisles'),
  class: styles.twentyFourSeven,
}

/** 24Seven (a 7-Eleven parody): aisles as tiles over every product; a grid on the desktop. */
export function TwentyFourSevenApp({ os }: OsAppProps) {
  return <ShopApp os={os} skin={TWENTY_FOUR_SEVEN} />
}
